import React, {
  Component
} from 'react';

import Swiper from "swiper/dist/js/swiper.js";
import {connect} from 'react-redux'
import MoodboardActions, {selectors as MoodboardSelectors} from '../redux/CarousselMoodboardRedux'

class CarousselMoodboard extends Component {
  constructor(props) {
    super(props)
    this.state = {
      swiper: null,
      swiperDestroyed: false,
      swiperInit: false,
      inited: false
    }
  }

  componentDidMount() {

  }

  componentDidUpdate() {
    if (this.props.visible && !this.state.inited) {
      this.initSwiper();
      let close = document.querySelector(".close-caroussel")
      close.addEventListener("click", () => {
        this.closeCaroussel()
      }, false)
    }
  }


  closeCaroussel() {
    this.props.setHidden();
    this.setState({
      inited: false
    })
  }

  initSwiper() {
    let swiper = new Swiper(".swiper-container", {
      loop: true,
      nextButton: ".swiper-next",
      prevButton: ".swiper-prev",
    })

    swiper.slideTo((parseInt(this.props.index) + 1), 0);

    this.setState({
      swiper: swiper,
      inited: true
    })

    swiper.on('onSlideChangeStart', (e) => this.slideChange(e));
    this.setText(this.props.index)
  }

  slideChange(e, f) {
    let nextIndex = document.querySelector('.swiper-slide-active').getAttribute("data-swiper-slide-index");
    this.setText(nextIndex)

  }

  setText(index) {
    let node = this.props.slides[index];
    document.querySelector('.moodboard-caroussel .copyright-container').innerHTML = node.copyright ? `<div class="copyright">${node.copyright}</div>` : '';
    document.querySelector('.moodboard-caroussel .text-container').innerHTML = (node.title && `<p class="title">${node.title}</p>`) + (node.text && `<p class="text">${node.text}</p>`);
  }

  render() {
    const Slides = this.props.slides.map((slider, key) => {
      return (
        <div key={key} className="image-container swiper-slide">
          <div className="content">
            <img src={slider.src} className="caroussel-image" alt={slider.alt} loading="lazy"/>
          </div>
        </div>
      )
    })


    return <div>
      {
        this.props.visible &&
        <div className="moodboard-caroussel">
          <div className="close-caroussel">
            <div className="square-button background-color-white">
              <div className="wrap-icon">
                <i className="icon-close color-primary-color"></i>
              </div>
            </div>
          </div>
          <div className="image-text-container-table">
            <div className="image-text-container">
              <div className="swiper-container">
                <div className="swiper-prev">
                  <div className="square-button background-primary-color">
                    <div className="wrap-icon">
                      <i className="icon-arrow left"></i>
                    </div>
                  </div>
                </div>
                <div className="swiper-next">
                  <div className="square-button background-primary-color">
                    <div className="wrap-icon">
                      <i className="icon-arrow right"></i>
                    </div>
                  </div>
                </div>
                <div className="swiper-wrapper">
                  {Slides}
                </div>
              </div>
              <div className="copyright-container">
              </div>
              <div className="text-container">
                <p>
                </p>
              </div>
            </div>
          </div>
        </div>
      }
    </div>
  }
}


const mapSelectors = (state) => {
  return {
    visible: MoodboardSelectors.visible(state),
    index: MoodboardSelectors.index(state),
  }
}

const mapActions = (dispatch) => {
  return {
    setHidden: () => dispatch(MoodboardActions.moodboardSetPopinVisible(false))
  }
}

export default connect(mapSelectors, mapActions)(CarousselMoodboard)


// WEBPACK FOOTER //
// ./resources/assets/frontend/js/components/CarousselMoodboard.js